/** Prefix on our console output so it's distinguishable in a host page. */
export const CONSOLE_LOG_IDENTIFIER = "[Local Logic] ";
